import Vue from "vue";
import VueRouter from "vue-router";
import VueCookies from "vue-cookies-reactive";

import { isUserLoggedIn } from "@/auth/utils";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    base: "/",
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: "/",
            redirect: `/:prefix/dashboard`,
            name: "home"
        },
        {
            path: "/:prefix/dashboard",
            name: "my-config",
            component: () => import("@/views/pages/pageTest/test.vue"),
            meta: {}
        },
        {
            path: "/:prefix/company-settings/resources",
            name: "resources",
            component: () => import("@/views/pages/resources/index.vue"),
            meta: {
                breadcrumb: [
                    {
                        text: "Breadcrumbs.CompanySettings",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.Resources",
                        active: true,
                        icon: ""
                    }
                ]
            }
        },
        {
            path: "/:prefix/company-settings/departments",
            name: "departments",
            component: () => import("@/views/pages/departments/index.vue"),
            meta: {
                breadcrumb: [
                    {
                        text: "Breadcrumbs.CompanySettings",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.Departments",
                        active: true,
                        icon: ""
                    }
                ]
            }
        },
        {
            path: "/:prefix/company-settings/organizational-structure",
            name: "organizational-structure",
            component: () => import("@/views/pages/organizationalStructure/index.vue"),
            meta: {
                breadcrumb: [
                    {
                        text: "Breadcrumbs.CompanySettings",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.OrganizationalStructure",
                        active: true,
                        icon: ""
                    }
                ]
            }
        },
        {
            path: "/:prefix/company-settings/security/profiles",
            name: "profiles",
            component: () => import("@/views/pages/profile/index.vue"),
            meta: {
                breadcrumb: [
                    {
                        text: "Breadcrumbs.CompanySettings",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.Security",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.Profile",
                        active: true,
                        icon: ""
                    }
                ]
            }
        },
        {
            path: "/:prefix/company-settings/security/people",
            name: "people",
            component: () => import("@/views/pages/people/index.vue"),
            meta: {
                breadcrumb: [
                    {
                        text: "Breadcrumbs.CompanySettings",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.Security",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.People",
                        active: true,
                        icon: ""
                    }
                ]
            }
        },
        {
            path: "/:prefix/company-settings/security/integration-keys",
            name: "integration-keys",
            component: () => import("@/views/pages/integrationKeys/index.vue"),
            meta: {
                breadcrumb: [
                    {
                        text: "Breadcrumbs.CompanySettings",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.Security",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.IntegrationKeys",
                        active: true,
                        icon: ""
                    }
                ]
            }
        },
        {
            path: "/:prefix/manufacturing/materials",
            name: "materials",
            component: () => import("@/views/pages/materials/index.vue"),
            meta: {
                breadcrumb: [
                    {
                        text: "Breadcrumbs.Manufacturing",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.Materials",
                        active: true,
                        icon: ""
                    }
                ]
            }
        },
        {
            path: "/:prefix/manufacturing/production-orders",
            name: "orders",
            component: () => import("@/views/pages/productionOrders/index.vue"),
            meta: {
                breadcrumb: [
                    {
                        text: "Breadcrumbs.Manufacturing",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.ProductionOrders",
                        active: true,
                        icon: ""
                    }
                ]
            }
        },
        {
            path: "/:prefix/manufacturing/operational-status",
            name: "operational-status",
            component: () => import("@/views/pages/operationalStatus/index.vue"),
            meta: {
                breadcrumb: [
                    {
                        text: "Breadcrumbs.Manufacturing",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.OperationalStatus",
                        active: true,
                        icon: ""
                    }
                ]
            }
        },
        {
            path: "/:prefix/manufacturing/rejection-reasons",
            name: "refuse-status",
            component: () => import("@/views/pages/rejectionReasons/index.vue"),
            meta: {
                breadcrumb: [
                    {
                        text: "Breadcrumbs.Manufacturing",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.RejectionReasons",
                        active: true,
                        icon: ""
                    }
                ]
            }
        },
        {
            path: "/:prefix/manufacturing/calendar/standard",
            name: "standard",
            component: () => import("@/views/pages/calendar/standard/index.vue"),
            meta: {
                breadcrumb: [
                    {
                        text: "Breadcrumbs.Manufacturing",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.Calendar",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.Standard",
                        active: true,
                        icon: ""
                    }
                ]
            }
        },
        {
            path: "/:prefix/manufacturing/calendar/exception",
            name: "exception",
            component: () => import("@/views/pages/calendar/exception/index.vue"),
            meta: {
                breadcrumb: [
                    {
                        text: "Breadcrumbs.Manufacturing",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.Calendar",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.Exception",
                        active: true,
                        icon: ""
                    }
                ]
            }
        },
        {
            path: "/:prefix/manufacturing/calendar/create",
            name: "newCalendar",
            component: () => import("@/views/pages/calendar/actionCalendar/index.vue"),
            meta: {
                breadcrumb: [
                    {
                        text: "Breadcrumbs.Manufacturing",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.Calendar",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.Standard",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "DepartmentPage.Create",
                        active: true,
                        icon: ""
                    }
                ]
            }
        },
        {
            path: "/:prefix/manufacturing/calendar/edit/:id",
            name: "editCalendar",
            component: () => import("@/views/pages/calendar/actionCalendar/index.vue"),
            meta: {
                breadcrumb: [
                    {
                        text: "Breadcrumbs.Manufacturing",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.Calendar",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.Standard",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "DepartmentPage.Edit",
                        active: true,
                        icon: ""
                    }
                ]
            }
        },
        {
            path: "/:prefix/company-settings/data-fields",
            name: "data-fields",
            component: () => import("@/views/pages/dataFields/index.vue"),
            meta: {
                breadcrumb: [
                    {
                        text: "Breadcrumbs.CompanySettings",
                        active: false,
                        icon: ""
                    },
                    {
                        text: "Breadcrumbs.DataFields",
                        active: true,
                        icon: ""
                    }
                ]
            }
        },
        {
            path: "/logout",
            name: "logout",
            component: () => import("@/views/pages/logout/logout.vue"),
            meta: {
                layout: "full",
                action: "read",
                resource: "basic"
            }
        },
        {
            path: "/error-404",
            name: "error-404",
            component: () => import("@/views/error/Error404.vue"),
            meta: {
                layout: "full",
                action: "read",
                resource: "basic"
            }
        },
        {
            path: "/:prefix/not-authorized",
            name: "not-authorized",
            component: () => import("@/views/pages/miscellaneous/NotAuthorized.vue"),
            meta: {
                layout: "full",
                action: "read",
                resource: "basic"
            }
        },
        {
            path: "/:prefix/authenticate-required",
            name: "authenticate-required",
            component: () => import("@/views/pages/miscellaneous/AuthenticateRequired.vue"),
            meta: {
                layout: "full",
                action: "read",
                resource: "basic"
            }
        },
        {
            path: "*",
            redirect: "error-404"
        }
    ]
});

router.beforeEach((to, from, next) => {
    const { name, path } = to;

    let hasToken = !!localStorage.getItem("accessToken");
    const cookieUserInfo = VueCookies.get("userInfo");

    if (!hasToken && cookieUserInfo) {
        if (cookieUserInfo.temporaryToken || cookieUserInfo.accessToken) {
            localStorage.setItem(
                "accessToken",
                cookieUserInfo.temporaryToken || cookieUserInfo.accessToken
            );
            hasToken = true;
        }
        if (cookieUserInfo.userData) {
            localStorage.setItem("userData", JSON.stringify(cookieUserInfo.userData));
        }
        const company = VueCookies.get("company");
        if (company) localStorage.setItem("prefix", company);
    }

    const isLoggedIn = isUserLoggedIn();
    const authenticationPages = ["login", "forgot"];
    const isAuthenticationPage = authenticationPages.some((page) => path.includes(page));

    if (!name) return next();

    if (isLoggedIn && isAuthenticationPage) {
        if (name === "home" || name === "my-config") return next();
        return next({ name: "home" });
    }

    if (!isLoggedIn && !isAuthenticationPage) {
        const publicRoutes = ["logout", "not-authorized", "authenticate-required", "error-404"];
        if (publicRoutes.includes(name)) return next();

        const myIndLink = process.env.VUE_APP_MY_IND_URL || "https://sso.indsiders.com/";
        window.location.href = `${myIndLink}login`;
        return;
    }

    return next();
});

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById("loading-bg");
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

export default router;